import React from 'react';
import Animated from 'animated/lib/targets/react-dom';
import Easing from 'animated/lib/Easing';
import useGetDailyBonusData from 'shared/screens/DailySpin/hooks/useGetDailyBonusData';
import useAnimationHandler from 'shared/screens/DailySpin/hooks/useAnimationHandler';
import { animationStyleGenerator } from './utils';
import Wheel from './components/Wheel';
import StreakColumn from './components/StreakColumn/StreakColumn';
import BottomBar from './components/BottomBar/BottomBar';
import { HiddenContentWrapper, PageContainer } from './components/styledComponents';

export default function DailySpin(props) {
  const { dailyWheelAssets } = props;

  const {
    claimDailyBonus,
    step,
    changeStep,
    bonusInfo,
    spinnerItems,
    totalCoinsAfterTierBonus,
    showTotalCoins,
    showTotalLoyalty,
    dailyBonus,
    wheelBonus,
    totalLoyalty,
    currentTierBonus,
    isPhysicallyVerified,
    linkedAccount,
    loginStreakList,
    loginStreakFinalDayNum,
    loginStreakFinal,
    isLoading,
  } = useGetDailyBonusData({
    ...props,
    Easing,
    Animated,
  });

  const {
    nextStepHandler,
    animateWheelIn,
    bottomAnim,
    wheelInAnim,
    wheelPostSpinAnim,
    fastForwardButtonAnim,
    streakAnim,
    spinAnim,
  } = useAnimationHandler({
    claimDailyBonus,
    Easing,
    Animated,
    step,
    changeStep,
    bonusInfo,
  });

  const {
    fastForwardButtonAnimDeg,
    spinAnimDeg,
    wheelInAnimDeg,
    wheelPostSpinAnimDeg,
    streakAnimDeg,
    bottomAnimDeg,
    bottomBarAnimDeg,
  } = animationStyleGenerator(spinAnim, fastForwardButtonAnim, wheelInAnim, wheelPostSpinAnim, streakAnim, bottomAnim);

  return (
    <PageContainer background={dailyWheelAssets.DAILY_SPIN_BACKGROUND}>
      <Wheel
        step={step}
        wheelInAnimDeg={wheelInAnimDeg}
        wheelPostSpinAnimDeg={wheelPostSpinAnimDeg}
        spinnerItems={spinnerItems}
        spinAnimDeg={spinAnimDeg}
        fastForwardButtonAnimDeg={fastForwardButtonAnimDeg}
        animateWheelIn={animateWheelIn}
        nextStepHandler={nextStepHandler}
      />

      <HiddenContentWrapper>
        <StreakColumn
          streakAnimDeg={streakAnimDeg}
          bottomAnimDeg={bottomAnimDeg}
          loginStreakFinal={loginStreakFinal}
          loginStreakList={loginStreakList}
          bonusInfo={bonusInfo}
          loginStreakFinalDayNum={loginStreakFinalDayNum}
        />
        <BottomBar
          isLoading={isLoading}
          bottomBarAnimDeg={bottomBarAnimDeg}
          wheelBonus={wheelBonus}
          dailyBonus={dailyBonus}
          isPhysicallyVerified={isPhysicallyVerified}
          linkedAccount={linkedAccount}
          currentTierBonus={currentTierBonus}
          showTotalCoins={showTotalCoins}
          totalCoinsAfterTierBonus={totalCoinsAfterTierBonus}
          totalLoyalty={totalLoyalty}
          nextStepHandler={nextStepHandler}
          showTotalLoyalty={showTotalLoyalty}
          step={step}
        />
      </HiddenContentWrapper>
    </PageContainer>
  );
}

